export class ScanFilters {
    [key: string]: boolean | Function;

    fullScanAnyPercent: boolean = true;
    fullScanTapPercent: boolean = false;
    fullScanGBPercent: boolean = false;
    fullScanAmpPercent: boolean = false;
    fullScanNodePercent: boolean = false;
    fullScanOtherPercent: boolean = false;
    ingressNarrowAnyPercent: boolean = true;
    ingressNarrowTapPercent: boolean = false;
    ingressNarrowOtherPercent: boolean = false;
    ingressNarrowGBPercent: boolean = false;
    ingressNarrowAmpPercent: boolean = false;
    ingressNarrowNodePercent: boolean = false;
    speedTestAnyPercent: boolean = true;
    speedTestTapPercent: boolean = false;
    speedTestGBPercent: boolean = false;
    speedTestAmpPercent: boolean = false;
    speedTestNodePercent: boolean = false;
    speedTestOtherPercent: boolean = false;
    howlerAnyPercent: boolean = false;
    howlerTapPercent: boolean = false;
    howlerGBPercent: boolean = false;
    howlerAmpPercent: boolean = false;
    howlerNodePercent: boolean = false;
    howlerOtherPercent: boolean = false;
    qotAnyPercent: boolean = false;
    qotTapPercent: boolean = false;
    qotGBPercent: boolean = false;
    qotAmpPercent: boolean = false;
    qotNodePercent: boolean = false;
    qotOtherPercent: boolean = false;
    noiseAnyPercent: boolean = false;
    noiseTapPercent: boolean = false;
    noiseGBPercent: boolean = false;
    noiseAmpPercent: boolean = false;
    noiseNodePercent: boolean = false;
    noiseOtherPercent: boolean = false;
    ofdmAnyPercent: boolean = false;
    ofdmTapPercent: boolean = false;
    ofdmGBPercent: boolean = false;
    ofdmAmpPercent: boolean = false;
    ofdmNodePercent: boolean = false;
    ofdmOtherPercent: boolean = false;
    photoAnyPercent: boolean = false;
    photoTapPercent: boolean = false;
    photoGBPercent: boolean = false;
    photoAmpPercent: boolean = false;
    photoNodePercent: boolean = false;
    photoOtherPercent: boolean = false;
    usAlignAnyPercent: boolean = false;
    usAlignTapPercent: boolean = false;
    usAlignGBPercent: boolean = false;
    usAlignAmpPercent: boolean = false;
    usAlignNodePercent: boolean = false;
    usAlignOtherPercent: boolean = false;
    dsAlignAnyPercent: boolean = false;
    dsAlignTapPercent: boolean = false;
    dsAlignGBPercent: boolean = false;
    dsAlignAmpPercent: boolean = false;
    dsAlignNodePercent: boolean = false;
    dsAlignOtherPercent: boolean = false;
    dropValidationAnyPercent: boolean = false;
}
